import script from "./FormCheckList.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCheckList.vue?vue&type=script&setup=true&lang=js"

import "./FormCheckList.vue?vue&type=style&index=0&id=59de12de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59de12de"]])

export default __exports__